import app from "flarum/forum/app";
import PlayerPage from "../ServerPlayer/PlayerPage";
import Placeholder from "flarum/common/components/Placeholder";
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import PlayerStatData from "./PlayerStatData";

export default class PlayerDataPage extends PlayerPage {
  loading = false;
  data = null;
  failedReason: string | null = null;
  playerXHR: XMLHttpRequest | null = null;
  retryTimeout: number | null = null;

  playerDataUrl(steamid: string) {
    return "https://rhd-api.tenmahw.com/zs/player/info?steamid=" + steamid;
  }

  dataComponent(data: any) {
    return <PlayerStatData player={data}/>;
  }

  processData(data: any) {
    return data;
  }

  oninit(vnode: any) {
    super.oninit(vnode);

    //this.refresh();
  }

  onremove(vnode: any) {
    super.onremove(vnode);

    if (this.retryTimeout) clearTimeout(this.retryTimeout);
    if (this.playerXHR) this.playerXHR.abort();
  }

  content() {
    if (!m.route.param("steamid")) {
      return <div className="PostsUserPage">
        <Placeholder text={app.translator.trans('rhodes-island.forum.user.player_data_not_available')} />
      </div>;
    }

    /*if (this.loading) {
      return <LoadingIndicator/>;
    } else if (this.data) {
      return this.dataComponent(this.data);
    } else {
      return <Placeholder text={app.translator.trans(this.failedReason || "rhodes-island.forum.player.load_failed")} />;
    }*/
    return <Placeholder text={app.translator.trans("rhodes-island.forum.under_maintenance")} />;
  }

  handleError() {
    const data = this.playerXHR?.response
    if (data) {
      if (data.reason) {
        if (data.reason == "玩家无效") {
          this.failedReason = "rhodes-island.forum.player.invalid_player";
          return;
        }
      }
    }
    //@ts-ignore
    this.retryTimeout = setTimeout(() => this.refresh(), 3000);
  }

  refresh() {
    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
    this.loading = true;
    this.data = null;

    m.redraw();

    if (!m.route.param("steamid")) {
      this.loading = false;
    } else {
      m.request({
        url: this.playerDataUrl(m.route.param("steamid")),
        config: (xhr: XMLHttpRequest) => this.playerXHR = xhr
      }).then((data: any) => {
        if (data.success) {
          this.data = this.processData(data.info);
          m.redraw();
        } else {
          this.handleError();
        }
      }).catch(() => this.handleError()).finally(() => this.loading = false);
    }
  }
}
